










































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import Fuse from 'fuse.js'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

Vue.component('DynamicScroller', DynamicScroller)
Vue.component('DynamicScrollerItem', DynamicScrollerItem)

@Component

export default class ComponentModalSearch extends Vue {
  @Prop(Array) filters
  @Prop(Array) items
  @Prop(Boolean) show
  @Prop(String) placeholder
  @Prop(Array) properties

  search: String = ''
  typing: Boolean = false
  wrapHeigth: Number = 750

  get itemsFiltered() {
    const filterResult = this.filter(this.search)

    if (!this.search) return this.items
    return filterResult
  }

  @Watch('search')
  watchSearch(newValue) {
    this.filter(newValue)
  }

  @Watch('show')
  watchShow(newValue) {
    this.toggleBodyOverflow()

    setInterval(() => {
      if (newValue) this.calculateHeight()
    }, 100)
  }

  @Emit('close')
  hide() {
    this.search = ''
  }

  @Emit('select')
  select(item, index) {
    this.hide()
  }

  mounted() {
    window.addEventListener('resize', this.calculateHeight)
  }

  calculateHeight() {
    const { filterHeader, filterPanel }: any = this.$refs

    const bodyHeight = document.body.scrollHeight
    const bodyWidth = document.body.clientWidth

    if (bodyHeight < 800 && bodyWidth <= 767) this.wrapHeigth = bodyHeight - 300
    else {
      const hasDom = filterPanel && filterPanel.clientHeight && filterHeader && filterHeader.clientHeight

      if (hasDom) {
        const wrapHeigth = (filterPanel.clientHeight - filterHeader.clientHeight - 50)
        this.wrapHeigth = wrapHeigth
      }
    }
  }

  filter(input) {
    const fuseOptions = {
      tokenize: true,
      matchAllTokens: true,
      threshold: 0.0,
      location: 0,
      distance: 20,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: this.filters,
    }

    const fuse = new Fuse(this.items, fuseOptions)
    const filterResult = fuse.search(input)

    return filterResult
  }

  toggleBodyOverflow() {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html) html.classList.toggle(noOverflowClass)
  }
}
